import { render } from "./WarehouseTransferItemForm.vue?vue&type=template&id=2b0f0364&scoped=true&ts=true"
import script from "./WarehouseTransferItemForm.vue?vue&type=script&lang=ts"
export * from "./WarehouseTransferItemForm.vue?vue&type=script&lang=ts"

import "./WarehouseTransferItemForm.vue?vue&type=style&index=0&id=2b0f0364&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0f0364"]])

export default __exports__